/**
 * parallel-mods.js: Mega Office Supplies behaviour mods for the
 * Parallel search widget. parallel.js stays the untouched template
 * (per Josh Rose, 9 Sep 2026); all changes live here.
 *
 * 1. "1 Products found" -> "1 Product found"
 * 2. Single match -> go straight to the product page (PDP).
 *    Only on /search, only when there are no filters or sort applied,
 *    only once per search term per browser tab. Back goes to the page
 *    the customer searched from, not back to a one-result page.
 */
(function () {
  'use strict';

  if (!/^\/search\/?$/.test(window.location.pathname)) {
    return;
  }

  var params = new URLSearchParams(window.location.search);
  var query = (params.get('q') || '').trim();

  /* Anything beyond the search term (filters, sort, page) means the
     customer is refining. Never jump them away in that case. */
  var extraParams = Array.from(params.keys()).filter(function (key) {
    return ['q', 'type', 'options[prefix]', '_pos', '_sid', '_ss'].indexOf(key) === -1;
  });

  var jumpAllowed = query !== '' && extraParams.length === 0;
  var jumpKey = 'mos-parallel-jump:' + query.toLowerCase();
  var jumped = false;

  function alreadyJumped() {
    try {
      return sessionStorage.getItem(jumpKey) === '1';
    } catch (e) {
      return false;
    }
  }

  function markJumped() {
    try {
      sessionStorage.setItem(jumpKey, '1');
    } catch (e) {
      /* storage blocked: the replace() below still prevents a back-button loop */
    }
  }

  function isLoading() {
    var loading = document.getElementById('gen-loading-message');
    return !!(loading && loading.offsetParent !== null);
  }

  function fixCountWording() {
    var count = document.querySelector('.gen-results-count');
    if (!count || !count.parentElement) {
      return;
    }
    var isOne = count.textContent.trim() === '1';
    count.parentElement.childNodes.forEach(function (node) {
      if (node.nodeType !== 3) {
        return;
      }
      var text = node.textContent;
      var fixed = isOne
        ? text.replace(/\bProducts found\b/, 'Product found')
        : text.replace(/\bProduct found\b/, 'Products found');
      if (fixed !== text) {
        node.textContent = fixed;
      }
    });
  }

  function trySingleResultJump() {
    if (!jumpAllowed || jumped || isLoading() || alreadyJumped()) {
      return;
    }
    var count = document.querySelector('.gen-results-count');
    var cards = document.querySelectorAll(
      '#gen-results-grid li[data-parallel-product-card="true"]'
    );
    if (!count || count.textContent.trim() !== '1' || cards.length !== 1) {
      return;
    }
    var link = cards[0].querySelector('a[href*="/products/"]');
    var url = cards[0].getAttribute('data-product-url') || (link && link.getAttribute('href'));
    if (!url || url.indexOf('/products/') === -1) {
      return;
    }
    jumped = true;
    markJumped();
    window.location.replace(url);
  }

  function run() {
    fixCountWording();
    trySingleResultJump();
  }

  var queued = false;
  function schedule() {
    if (queued) {
      return;
    }
    queued = true;
    /* setTimeout, not requestAnimationFrame: rAF is paused in background
       tabs, so a search opened in a new tab would never be processed. */
    window.setTimeout(function () {
      queued = false;
      run();
    }, 50);
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/**
 * 2026-09-24 (ported from PoscART v25 / Dymo)
 * 3. Two-decimal prices on every Parallel card (search, collections,
 *    header dropdown): "$187" -> "$187.00", "$41.5" -> "$41.50".
 *    Idempotent, re-runs whenever Parallel re-renders.
 * 4. Search page tab title: `AI Search Results "q"` ->
 *    `Search results for "q" | Mega Office Supplies`.
 */
(function () {
  'use strict';

  var RE = /(\$\s?)(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{1,2}))?(?![\d.])/g;

  function pad(s) {
    return s.replace(RE, function (m, cur, whole, dec) {
      return cur + whole + '.' + ((dec || '') + '00').slice(0, 2);
    });
  }

  function fixPrices() {
    var els = document.querySelectorAll('[data-parallel-product-card] .product-price');
    for (var i = 0; i < els.length; i++) {
      var w = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var v = pad(n.nodeValue);
        if (v !== n.nodeValue) n.nodeValue = v;
      }
    }
  }

  function fixTitle() {
    var m = document.title.match(/^AI Search Results\s+"(.*)"$/);
    if (m) document.title = 'Search results for "' + m[1] + '" | Mega Office Supplies';
  }

  var t;
  function start() {
    fixPrices();
    fixTitle();
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(fixPrices, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    var titleEl = document.querySelector('title');
    if (titleEl) {
      new MutationObserver(fixTitle).observe(titleEl, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* MOS 2026-09-24: Parallel's collection/search API returns productUrl as the full
   https://mega-office-supplies.myshopify.com/... address with no handle, so its cards link to the
   myshopify domain (visible on hover, one redirect hop, cross-domain internal links for Google).
   Rewrite those hrefs to relative paths as soon as the cards are inserted. Remove once Parallel
   returns relative URLs or the primary domain. */
(function () {
  'use strict';
  var RE = /^https?:\/\/mega-office-supplies\.myshopify\.com(?=\/(?:products|collections|pages|blogs)\/)/i;
  function fixEl(el) {
    ['href', 'data-product-url'].forEach(function (attr) {
      var v = el.getAttribute(attr);
      if (v && RE.test(v)) el.setAttribute(attr, v.replace(RE, ''));
    });
  }
  function fixAll(root) {
    var els = (root || document).querySelectorAll('a[href*="myshopify.com"], [data-product-url*="myshopify.com"]');
    for (var i = 0; i < els.length; i++) fixEl(els[i]);
  }
  function start() {
    fixAll(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('a[href*="myshopify.com"], [data-product-url*="myshopify.com"]')) fixEl(n);
          if (n.querySelectorAll) fixAll(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href*="myshopify.com"]');
      if (a) fixEl(a);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
(function(){"use strict";
/* MOS 2026-09-29 v2 — partial SKU / supplier-code search (stopgap until Parallel covers it).
   Runs only when a code-like query comes back from Parallel without any product whose SKU
   contains the typed code. Looks the code up in the Stock Finder feed (itf-find.json: our SKU
   + supplier code) and puts the matches first. Nothing is removed from Parallel's results.
   Match order, first that gives 1-8 products wins:
     1. exact: our SKU without its letter prefix, or the supplier code  (4+ chars)
     2. end of a code    e.g. 28307   -> S2128307   (5+ chars)
     3. start of a code  e.g. GN85590 -> GN85590.27 (5+ chars)
     4. inside a code    e.g. 85590   -> GN85590.27 (5+ chars)
   Limits measured on the live catalogue 2026-09-29: 5-char tails are unique 77% of the time and
   hit <=5 products 93% of the time; 4-char tails and 3-char codes (e.g. "141") are too ambiguous. */
if(window.__mosSkuAlias)return;window.__mosSkuAlias=2;
var FEED="/cdn/shop/files/itf-find.json",MAX=8,MIN_PART=5,orig=window.fetch;
if(typeof orig!=="function")return;
function norm(s){return String(s==null?"":s).toLowerCase().replace(/[^0-9a-z]/g,"")}
function codeLike(q){q=String(q||"").trim();if(!q||/\s/.test(q))return"";var n=norm(q);return n.length>=4&&/\d/.test(n)?n:""}
var dataP=null;
function loadData(){if(dataP)return dataP;var h=Math.floor(Date.now()/36e5);
dataP=orig.call(window,FEED+"?h="+h).then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(d){
var alias=new Map(),rows=[];
function add(k,sku,own){if(k.length<4||!/\d/.test(k)||k===own)return;var a=alias.get(k);if(!a)alias.set(k,a=[]);if(a.indexOf(sku)<0)a.push(sku)}
(d&&d.p||[]).forEach(function(p){var sku=p[0],own=norm(sku),sup=norm(p[6]),mm=own.match(/^[a-z]{1,5}(.+)$/);
if(mm)add(mm[1],sku,own);add(sup,sku,own);rows.push([sku,own,sup])});
return{alias:alias,rows:rows}}).catch(function(){dataP=null;return{alias:new Map(),rows:[]}});return dataP}
function find(db,n){var a=db.alias.get(n);if(a&&a.length&&a.length<=MAX)return a;
if(n.length<MIN_PART)return[];
var tests=[function(c){return c.length>n.length&&c.slice(-n.length)===n},function(c){return c.length>n.length&&c.indexOf(n)===0},function(c){return c.indexOf(n)>0}];
for(var t=0;t<tests.length;t++){var out=[];for(var i=0;i<db.rows.length;i++){var r=db.rows[i];if(tests[t](r[1])||(r[2]&&tests[t](r[2]))){out.push(r[0]);if(out.length>MAX)break}}
if(out.length&&out.length<=MAX)return out;if(out.length>MAX)return[]}return[]}
function hasCode(pr,n){if(norm(pr&&pr.sku).indexOf(n)>=0)return true;var v=pr&&pr.variants;return Array.isArray(v)&&v.some(function(x){return norm(x&&x.sku).indexOf(n)>=0})}
window.fetch=function(input,init){var args=arguments,self=this;
var url=typeof input==="string"?input:input&&input.url||"";
var ep=/api\.storefrontagent\.com\/agents\/(search|suggest)\b/.exec(url);
if(!ep||!init||typeof init.body!=="string")return orig.apply(self,args);
var body;try{body=JSON.parse(init.body)}catch(e){return orig.apply(self,args)}
var isSearch=ep[1]==="search"&&body.event_type==="search_request",isSug=ep[1]==="suggest"&&body.event_type==="predictive_search";
if(!isSearch&&!isSug)return orig.apply(self,args);
if(isSearch&&((body.page||1)!==1||body.filters&&Object.keys(body.filters).length))return orig.apply(self,args);
var n=codeLike(isSearch?body.search_term:body.search_query);if(!n)return orig.apply(self,args);
return orig.apply(self,args).then(function(res){if(!res||!res.ok)return res;
return res.clone().json().then(function(data){var prods=data&&Array.isArray(data.products)?data.products:null;
if(!prods||prods.some(function(p){return hasCode(p,n)}))return res;
return loadData().then(function(db){var skus=find(db,n);if(!skus.length)return res;
return Promise.all(skus.map(function(sku){var b=JSON.parse(init.body);if(isSearch){b.search_term=sku;b.limit=5}else b.search_query=sku;
return orig.call(window,url,{method:"POST",headers:init.headers,body:JSON.stringify(b),signal:init.signal}).then(function(r){return r.ok?r.json():null}).then(function(d){
var ps=d&&Array.isArray(d.products)?d.products:[],k=norm(sku);return ps.filter(function(p){return norm(p.sku)===k||(p.variants||[]).some(function(v){return norm(v&&v.sku)===k})})[0]||null}).catch(function(){return null})}))
.then(function(found){var seen={},top=[];found.forEach(function(f){if(f&&!seen[f.product_id]){seen[f.product_id]=1;top.push(Object.assign({},f,{relevance_score:Math.max(1,+f.relevance_score||0)}))}});
if(!top.length)return res;var rest=prods.filter(function(p){return!seen[p&&p.product_id]}),added=top.length-(prods.length-rest.length);
data.products=top.concat(rest);if(typeof data.result_count==="number")data.result_count+=added;if(data.pagination&&typeof data.pagination.result_count==="number")data.pagination.result_count+=added;
var hd=new Headers(res.headers);hd.delete("content-length");hd.delete("content-encoding");
return new Response(JSON.stringify(data),{status:res.status,statusText:res.statusText,headers:hd})})})}).catch(function(){return res})})};
})();
(function(){"use strict";
/* MOS 2026-09-29 v8 — search result guard + speed safety net (stopgap until Parallel fixes it).
   Shopify's own Storefront search (~0.6s) is started AT THE SAME TIME as Parallel.
   Plain-word first page (codes are handled by the SKU block):
   A. SAFETY NET: if Parallel has not answered within TIMEOUT_MS (dropdown: SUGGEST_TIMEOUT_MS),
      show Shopify's matches instead, with Brand / Categories / Stock filters, sorting and
      "Load more" all served from Shopify. Parallel's late answer is dropped.
   B. THIN: Parallel returns fewer than MIN_RESULTS products ("calendar stand" gave 2).
   C. OFF-TARGET: fewer than MIN_FULL of Parallel's top 8 contain every word searched
      ("uni chalk" gave Dats chalk, "stat pens" gave Staedtler, "thermal roll 80x80").
      B puts all Shopify matches first. C puts only the ones whose TITLE contains every word first,
      unless none of Parallel's top 8 match at all - then Shopify's top matches are used as they are.
   Filter ticks, sorting and "Load more" (v8):
   - If the page's results came from Shopify, they are answered from Shopify straight away
     (Brand, Categories, Stock, price slider; Relevance / Price low-high / Price high-low).
   - If they came from Parallel, Parallel gets TIMEOUT_MS to answer a filter tick or sort before
     Shopify's answer is used. "Load more" always stays with whoever served the first page.
   - Anything Shopify can't do (colour, newest, best selling...) goes to Parallel as before. */
if(window.__mosBackfill)return;window.__mosBackfill=9;
var MIN_RESULTS=8,MIN_FULL=4,PER=24,TIMEOUT_MS=2000,SUGGEST_TIMEOUT_MS=1200,SHOP_AFTER_MS=900,SUGGEST_SHOP_AFTER_MS=600,BASE_AFTER_MS=900,MERGE_WAIT_MS=350,prev=window.fetch;
if(typeof prev!=="function")return;
var STOP={and:1,or:1,the:1,for:1,with:1,of:1,a:1,x:1,in:1,to:1,mm:1};
function norm(s){return String(s==null?"":s).toLowerCase().replace(/[^0-9a-z]/g,"")}
function words(s){return String(s||"").toLowerCase().replace(/(\d)\s*x\s*(\d)/g,"$1 $2").split(/[^0-9a-z]+/).filter(Boolean).map(function(w){return w.length>3&&/[a-z]s$/.test(w)&&!/ss$/.test(w)?w.slice(0,-1):w})}
function isCode(q){q=String(q||"").trim();return!/\s/.test(q)&&/\d/.test(q)}
function hasAll(title,terms){var set={};words(title).forEach(function(w){set[w]=1});return terms.every(function(t){return set[t]})}
function token(){try{return window.PARALLEL_PUBLIC_TOKEN||sessionStorage.getItem("parallel_public_token")||""}catch(e){return window.PARALLEL_PUBLIC_TOKEN||""}}
var GQL="query($q:String!,$n:Int!){search(query:$q,first:$n,types:PRODUCT){nodes{...on Product{id handle title vendor productType featuredImage{url} collections(first:12){nodes{title}} variants(first:1){nodes{id sku title availableForSale price{amount} compareAtPrice{amount}}}}}}}";
var SORTS=[{value:"relevance",label_key:"relevance",label:"Relevance"},{value:"featured",label_key:"featured",label:"Featured"},{value:"price-asc",label_key:"priceLowToHigh",label:"Price: low to high"},{value:"price-desc",label_key:"priceHighToLow",label:"Price: high to low"},{value:"newest",label_key:"newest",label:"Newest"},{value:"best-selling",label_key:"bestSelling",label:"Best selling"}];
/* ---- Shopify search: one pull of the top 250 per query, then filter / sort / page locally ----
   (Shopify's Storefront search here ignores vendor/type filters and matches very loosely, e.g.
   848 hits for "a4 exercise book", so we keep only products whose title, type, brand or
   collections contain every word searched - unless that leaves fewer than MIN_RESULTS.) */
var BASE={},SRC={},FACETS={},STATS={},POOL=250;
function hasVals(v){return Array.isArray(v)?v.length>0:v!=null&&v!==""}
function cleanFilters(f){var o={};Object.keys(f||{}).forEach(function(k){if(hasVals(f[k]))o[k]=f[k]});return o}
function row(p){var v=p&&p.variants&&p.variants.nodes&&p.variants.nodes[0];return v?{p:p,v:v,sku:v.sku||"",title:p.title}:null}
function gql(q,n){var t=token();if(!t)return Promise.resolve([]);
return prev.call(window,location.origin+"/api/2025-04/graphql.json",{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:GQL,variables:{q:q,n:n}})})
.then(function(r){return r.ok?r.json():null}).then(function(j){var s=j&&j.data&&j.data.search;return s?(s.nodes||[]).map(row).filter(Boolean):[]}).catch(function(){return[]})}
function relevant(q,rows){var t=words(q).filter(function(w){return!STOP[w]});if(!t.length)return rows;
var keep=rows.filter(function(x){var p=x.p;return hasAll([p.title,p.productType,p.vendor].concat((p.collections&&p.collections.nodes||[]).map(function(c){return c.title})).join(" "),t)});
if(keep.length>=MIN_RESULTS)return keep;
var need=Math.ceil(t.length/2),seen={};keep.forEach(function(x){seen[x.p.id]=1});
var near=rows.filter(function(x){if(seen[x.p.id])return false;var p=x.p,set={};words([p.title,p.productType,p.vendor].join(" ")).forEach(function(w){set[w]=1});
return t.filter(function(w){return set[w]}).length>=need});
keep=keep.concat(near);return keep.length>=MIN_RESULTS?keep:rows}
function base(q){return BASE[q]||(BASE[q]=gql(q,POOL).then(function(rows){var cards=relevant(q,rows).map(toCard);
if(cards.length){FACETS[q]=buildFacets(cards);STATS[q]=priceStats(cards)}return cards}))}
function shopifyTop(q){return gql(q,PER)}
/* Parallel filters -> a local test. null = something we can't do locally. */
function localFilter(f,pmin,pmax){var ok=true,tests=[];
Object.keys(f).forEach(function(k){var v=[].concat(f[k]).map(String);
if(k==="brand")tests.push(function(p){return v.indexOf(String(p.brand))>=0});
else if(k==="type")tests.push(function(p){return v.indexOf(String(p.type))>=0});
else if(k==="availability"){if(v.indexOf("In Stock")>=0)tests.push(function(p){return p.variants[0].is_available})}
else if(k==="price_min"){pmin=pmin||f[k]}else if(k==="price_max"){pmax=pmax||f[k]}
else ok=false});
if(!ok)return null;
if(pmin)tests.push(function(p){return p.price>=+pmin});if(pmax)tests.push(function(p){return p.price<=+pmax});
return function(p){return tests.every(function(t){return t(p)})}}
function localSort(s){if(!s||s==="relevance"||s==="featured")return function(a){return a};
if(/^price-asc/.test(s))return function(a){return a.slice().sort(function(x,y){return x.price-y.price})};
if(/^price-desc/.test(s))return function(a){return a.slice().sort(function(x,y){return y.price-x.price})};return null}
/* A Parallel-shaped product built from Shopify data (same fields the card renderer reads). */
function toCard(x){var p=x.p,v=x.v,price=+(v.price&&v.price.amount)||0,cmp=v.compareAtPrice?+v.compareAtPrice.amount:null;
return{product_id:p.id,imageUrl:p.featuredImage&&p.featuredImage.url||"",title:p.title,vendor:p.vendor,brand:p.vendor,type:p.productType,sku:v.sku,
productUrl:"/products/"+p.handle,price:price,lowest_price:price,compare_at_price:cmp,currency:"AUD",relevance_score:1,colors:[],metafields:{},collections:(p.collections&&p.collections.nodes||[]).map(function(c){return c.title}),
variants:[{id:v.id,sku:v.sku,title:v.title,image:null,price:price,compare_at_price:cmp,is_available:!!v.availableForSale,is_sellable:!!v.availableForSale}]}}
function respond(res,data){var hd=new Headers(res?res.headers:{"Content-Type":"application/json"});hd.delete("content-length");hd.delete("content-encoding");hd.set("Content-Type","application/json");
return new Response(JSON.stringify(data),{status:200,statusText:"OK",headers:hd})}
/* Brand / Categories / Stock side filters in Parallel's own facet shape. */
function termsF(prods,get,label,field,dl,lk){var c={};prods.forEach(function(p){var v=get(p);if(v)c[v]=(c[v]||0)+1});
var o=Object.keys(c).sort(function(a,b){return c[b]-c[a]||a.localeCompare(b)}).map(function(v){return{value:v,label:v,count:c[v]}});
return o.length?{label:label,field:field,type:"terms",options:o,default_label:dl,label_key:lk}:null}
function buildFacets(prods){return[
termsF(prods,function(p){return p.brand},"Brand","brand","Brand","brand"),
termsF(prods,function(p){return p.type},"Categories","type","Product Type","categories"),
termsF(prods,function(p){return p.variants[0].is_available?"In Stock":null},"Stock","availability","Availability","stock")].filter(Boolean)}
function priceStats(prods){var pr=prods.map(function(p){return+p.price}).filter(function(x){return x>0});return{min_price:pr.length?Math.min.apply(null,pr):0,max_price:pr.length?Math.max.apply(null,pr):0,currency:"AUD"}}
/* One page of local results as a Parallel search response. */
function pageData(q,all,page){var items=all.slice((page-1)*PER,page*PER),total=all.length,pages=Math.max(1,Math.ceil(total/PER));
return{products:items,result_count:total,filters:{},facets:page===1?(FACETS[q]||buildFacets(all)):[],sort_options:SORTS,
stats:STATS[q]||priceStats(all),
pagination:{result_count:total,begin:items.length?(page-1)*PER+1:0,end:(page-1)*PER+items.length,current_page:page,total_pages:pages,previous_page:page>1?page-1:0,next_page:page<pages?page+1:0,per_page:PER,default_per_page:PER},mos_fallback:true}}
function localKey(q,fl,sort){return JSON.stringify([q,fl,sort])}
function serveLocal(q,test,sorter,page,key){return base(q).then(function(cards){SRC[key]="shop";return respond(null,pageData(q,sorter(cards.filter(test)),page))})}
window.fetch=function(input,init){var args=arguments,self=this;
var url=typeof input==="string"?input:input&&input.url||"";
var ep=/api\.storefrontagent\.com\/agents\/(search|suggest)\b/.exec(url);
if(!ep||!init||typeof init.body!=="string")return prev.apply(self,args);
var body;try{body=JSON.parse(init.body)}catch(e){return prev.apply(self,args)}
var isSearch=ep[1]==="search"&&body.event_type==="search_request",isSug=ep[1]==="suggest"&&body.event_type==="predictive_search";
if(!isSearch&&!isSug)return prev.apply(self,args);
var q=String((isSearch?body.search_term:body.search_query)||"").trim();
if(q.length<3||isCode(q)||body.image_data)return prev.apply(self,args);
if(isSearch){var fl=cleanFilters(body.filters),page=body.page||1,sort=body.sort_by||"relevance",filtered=Object.keys(fl).length>0||!!body.price_min||!!body.price_max;
if(filtered||page!==1||(sort!=="relevance"&&sort!=="featured")){
var test=localFilter(fl,body.price_min,body.price_max),sorter=localSort(sort);
if(!test||!sorter)return prev.apply(self,args);                         /* can't do it locally */
var key=localKey(q,fl,sort),bkey=localKey(q,{},"relevance");
var src=SRC[key]||(page===1?SRC[bkey]:null);
if(src==="shop")return serveLocal(q,test,sorter,page,key);
if(page!==1)return prev.apply(self,args);                               /* Parallel's own paging */
var parF=prev.apply(self,args),timerF,toF=new Promise(function(r){timerF=setTimeout(function(){r("timeout")},TIMEOUT_MS)});
return Promise.race([parF,toF]).then(function(first){if(first==="timeout")return serveLocal(q,test,sorter,1,key);
clearTimeout(timerF);SRC[key]="parallel";return first})}}
var terms=words(q).filter(function(w){return!STOP[w]}),bkey=localKey(q,{},"relevance");
/* v9 (30 Sep): Shopify is only asked once Parallel is slow, so a fast Parallel answer has nothing
   competing with it, and a Parallel answer is never held back more than MERGE_WAIT_MS by us. */
var shopP=null,early=[];function getShop(){return shopP||(shopP=shopifyTop(q))}
if(isSearch&&terms.length>=2)getShop();   /* multi-word: one small (24) Shopify call now, so the all-words check never waits */
else early.push(setTimeout(getShop,isSug?SUGGEST_SHOP_AFTER_MS:SHOP_AFTER_MS));
if(isSearch)early.push(setTimeout(function(){base(q)},BASE_AFTER_MS));
var parP=prev.apply(self,args);
var timer,timedOut=new Promise(function(r){timer=setTimeout(function(){r("timeout")},isSug?SUGGEST_TIMEOUT_MS:TIMEOUT_MS)});
return Promise.race([parP,timedOut]).then(function(first){
if(first==="timeout"){return getShop().then(function(list){if(!list.length)return parP;
if(isSug)return respond(null,{products:list.map(toCard),result_count:list.length,mos_fallback:true});
return base(q).then(function(cards){if(!cards.length)return respond(null,pageData(q,list.map(toCard),1));SRC[bkey]="shop";return respond(null,pageData(q,cards,1))})})}
clearTimeout(timer);early.forEach(clearTimeout);var res=first;if(!res||!res.ok)return res;
if(isSearch)SRC[bkey]="parallel";
return res.clone().json().then(function(data){var prods=data&&Array.isArray(data.products)?data.products:null;if(!prods)return res;
var thin=prods.length<MIN_RESULTS,full=0;
if(!thin){if(terms.length<2)return res;prods.slice(0,8).forEach(function(p){if(hasAll(p&&p.title,terms))full++});if(full>=MIN_FULL)return res}
var cap=new Promise(function(r){setTimeout(function(){r(null)},MERGE_WAIT_MS)});
return Promise.race([getShop(),cap]).then(function(list){if(!list)return res;   /* Shopify not back in time: show Parallel's as is */
if(!thin&&full>0)list=list.filter(function(x){return hasAll(x.title,terms)});
if(!thin&&list.length<=full)return res;
var byKey={};prods.forEach(function(p){byKey[norm(p&&p.sku)]=p});
list=list.filter(function(x){return x.sku}).slice(0,8);if(!list.length)return res;
/* no extra Parallel calls: use Parallel's own card if it has the product, else build it from Shopify's data */
var seen={},top=[];list.forEach(function(x){var f=byKey[norm(x.sku)]||toCard(x);if(f&&!seen[f.product_id]){seen[f.product_id]=1;top.push(Object.assign({},f,{relevance_score:Math.max(1,+f.relevance_score||0)}))}});
if(!top.length)return res;var rest=prods.filter(function(p){return!seen[p&&p.product_id]}),added=top.length-(prods.length-rest.length);
data.products=top.concat(rest);
if(typeof data.result_count==="number")data.result_count+=added;if(data.pagination&&typeof data.pagination.result_count==="number")data.pagination.result_count+=added;
if(data.stats){var pr=data.products.map(function(p){return+p.price}).filter(function(x){return x>0});if(pr.length){data.stats.min_price=Math.min.apply(null,pr);data.stats.max_price=Math.max.apply(null,pr)}}
return respond(res,data)})}).catch(function(){return res})})};
})();
(function(){"use strict";
/* MOS 2026-09-29 v3 — AI assistant prompt on search results and collection pages, plus
   lifting the floating widgets off the bottom edge.
   - Search and collection pages: compact box on its own line, centred on the page, between the
     page heading and the "Products found / Relevance" row. Full width on phones.
   - Look: glassy white card, blue light chasing round the border, soft sheen gliding over it
     (matches Parallel's "Ask..." launcher). Motion switches off for prefers-reduced-motion.
   - Only shown once products have loaded. Clicking sends Mega Concierge a message describing
     the page (search term or collection, and how many products) so it picks up from there.
   - Lifts Parallel's "Ask..." launcher and Google's Customer Reviews badge ~20mm (76px) off
     the bottom of the screen, keeping their own stacking order.
   Uses window.ParallelEveV2Chat (the chat widget's own public API). Hidden if it is missing. */
if(window.__mosAskBar)return;window.__mosAskBar=7;
var LIFT="76px";
var lift="#shopify-ai-agent-v2.shop-ai-chat-container:not(.is-chat-open):not(.active){bottom:"+LIFT+"!important}"+
"#___ratingbadge_0{bottom:"+LIFT+"!important}";
(function(){var st=document.createElement("style");st.id="mos-lift-css";st.textContent=lift;(document.head||document.documentElement).appendChild(st)})();
var path=location.pathname,isSearch=/^\/search\/?$/.test(path),isCol=/^\/collections\/[^\/]+\/?$/.test(path);
if(!isSearch&&!isCol)return;
var q=isSearch?(new URLSearchParams(location.search).get("q")||"").trim():"";if(isSearch&&!q)return;
var css="@property --mos-a{syntax:'<angle>';inherits:false;initial-value:0deg}"+
".mos-askbox{position:relative;display:inline-flex;max-width:620px;border-radius:999px;padding:2px;isolation:isolate;"+
"background:conic-gradient(from var(--mos-a),rgba(30,63,143,.18) 0deg,rgba(30,63,143,.18) 200deg,#7fb0ff 260deg,#2f6bff 300deg,#1e3f8f 330deg,rgba(30,63,143,.18) 360deg);"+
"animation:mos-spin 3.2s linear infinite;box-shadow:0 10px 30px rgba(30,63,143,.16),0 2px 6px rgba(30,63,143,.08)}"+
".mos-askbox .mos-in{position:relative;overflow:hidden;display:flex;align-items:center;gap:12px;width:100%;padding:8px 8px 8px 18px;border-radius:999px;"+
"background:rgba(255,255,255,.92);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);font-size:14px;line-height:1.35;color:#1f2a44}"+
".mos-askbox .mos-in:after{content:'';position:absolute;inset:0;pointer-events:none;background:linear-gradient(105deg,transparent 30%,rgba(120,170,255,.28) 45%,rgba(255,255,255,.7) 50%,rgba(120,170,255,.28) 55%,transparent 70%);"+
"transform:translateX(-120%);animation:mos-sheen 4.5s ease-in-out infinite}"+
".mos-askbox .mos-spark{font-size:17px;line-height:1;color:#1e3f8f}.mos-askbox .mos-txt{flex:1 1 auto}.mos-askbox b{font-weight:600}"+
".mos-askbox button{position:relative;z-index:1;border:0;border-radius:999px;padding:9px 18px;background:#1e3f8f;color:#fff;font-weight:600;font-size:13.5px;cursor:pointer;white-space:nowrap}"+
".mos-askbox button:hover{background:#16306e}"+
"@keyframes mos-spin{to{--mos-a:360deg}}@keyframes mos-sheen{0%,55%{transform:translateX(-120%)}100%{transform:translateX(120%)}}"+
"@media(prefers-reduced-motion:reduce){.mos-askbox{animation:none}.mos-askbox .mos-in:after{animation:none;display:none}}"+
".mos-askrow{display:flex!important;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap}"+
".mos-askrow>.mos-askbox{margin-left:auto}"+
".mos-askcentre{display:flex;justify-content:center;width:100%;margin:0 0 12px}"+".mos-askcentre.mos-onhead{position:absolute;left:50%;width:auto;margin:0;transform:translate(-50%,-50%);z-index:2}"+
"@media(max-width:749px){.mos-askbox{display:flex;width:100%;border-radius:18px}.mos-askbox .mos-in{border-radius:16px;flex-wrap:wrap}.mos-askbox button{width:100%}.mos-askrow>.mos-askbox{margin-left:0}}";
function colName(){var h=document.querySelector("h1");return h?h.textContent.replace(/\s+/g," ").trim():""}
function count(){var c=document.querySelector(".gen-results-count"),n=c?parseInt(c.textContent.replace(/[^0-9]/g,""),10):NaN;
if(isNaN(n)){var m=(document.body.innerText.match(/(\d[\d,]*)\s+Products?\b/)||[])[1];n=m?parseInt(m.replace(/,/g,""),10):NaN}return isNaN(n)?0:n}
function message(){var n=count();
if(isSearch)return'I searched for "'+q+'"'+(n?" and got "+n+" results":"")+". Please help me narrow them down. Ask me one short question at a time, with a few options to choose from, and don't show any products until I've answered.";
var name=colName();return"I'm browsing "+(name||"this collection")+(n?" ("+n+" products)":"")+". Please help me narrow these down. Ask me one short question at a time, with a few options to choose from, and don't show any products until I've answered."}
var sent=false;   /* only the first click sends the page context; later clicks just reopen the chat */
function openChat(){var api=window.ParallelEveV2Chat;if(!api)return;
try{if(!sent&&api.sendMessage&&api.sendMessage(message())){sent=true;return}api.open()}catch(e){try{api.open()}catch(e2){}}}
function build(){var box=document.createElement("div");box.className="mos-askbox";
var inn=document.createElement("div");inn.className="mos-in";
var sp=document.createElement("span");sp.className="mos-spark";sp.textContent="✦";
var tx=document.createElement("span");tx.className="mos-txt";tx.innerHTML=isSearch?"<b>Not quite what you're looking for?</b>":"<b>Looking for something specific?</b>";
var b=document.createElement("button");b.type="button";b.textContent=isSearch?"Ask our assistant":"Narrow these down";b.addEventListener("click",openChat);
inn.appendChild(sp);inn.appendChild(tx);inn.appendChild(b);box.appendChild(inn);return box}
function css1(){if(!document.getElementById("mos-askbox-css")){var st=document.createElement("style");st.id="mos-askbox-css";st.textContent=css;document.head.appendChild(st)}}
/* Desktop search page: move the box up onto the "Search Results" heading line, centred on the page,
   so it takes no height of its own. Skipped if it would touch the heading text. Collection pages and
   phones keep it on its own (compact) row. */
function onHead(wrap){if(!isSearch)return;var h=document.querySelector(".rich-text__heading, h1");if(!h)return;
var home=wrap.parentNode,next=wrap.nextSibling,host=h.parentNode;
function textRight(){var r=document.createRange();r.selectNodeContents(h);return r.getBoundingClientRect().right}
function fit(){if(innerWidth>=990){if(wrap.parentNode!==host){if(getComputedStyle(host).position==="static")host.style.position="relative";host.appendChild(wrap)}
var hr=h.getBoundingClientRect(),pr=host.getBoundingClientRect(),bw=wrap.firstChild.getBoundingClientRect().width,cx=innerWidth/2;
if(textRight()+24<cx-bw/2){wrap.classList.add("mos-onhead");wrap.style.left=(cx-pr.left)+"px";wrap.style.top=(hr.top+hr.height/2-pr.top)+"px";return}}
wrap.classList.remove("mos-onhead");wrap.style.top=wrap.style.left="";if(wrap.parentNode!==home)home.insertBefore(wrap,next&&next.parentNode===home?next:home.firstChild)}
fit();addEventListener("resize",fit)}
function place(){if(!window.ParallelEveV2Chat)return false;var grid=document.getElementById("gen-results-grid");
if(!grid||!grid.querySelector("[data-parallel-product-card]"))return false;          /* wait for products */
if(document.querySelector(".mos-askbox"))return true;css1();
var hdr=document.querySelector(".gen-results-header");
if(hdr&&hdr.parentNode){var wrap=document.createElement("div");wrap.className="mos-askcentre";wrap.appendChild(build());
hdr.parentNode.insertBefore(wrap,hdr);onHead(wrap);return true}
var layout=grid.closest(".gen-search-layout")||grid.parentNode;layout.parentNode.insertBefore(build(),layout);return true}
new MutationObserver(function(){if(!document.querySelector(".mos-askbox"))place()}).observe(document.body,{childList:true,subtree:true});
place();
})();
(function(){"use strict";
/* MOS 2026-09-29 — "why is this taking a while" notes.
   1. Search results page: if Parallel's loader ("Understanding intent" / "Reasoning") is still
      showing after WAIT_MS, a line appears under it. Goes away with the loader.
   2. Mega Concierge chat: if the assistant's status line ("Checking conversation context" /
      "Thinking") is still showing after WAIT_MS, the same kind of line appears under it. It lives
      inside Parallel's status bubble, so it disappears when the real answer replaces the bubble.
   Nothing of Parallel's is changed or hidden. The catalogue holds 30,500+ products (itf-find). */
if(window.__mosWaitNote)return;window.__mosWaitNote=1;
var WAIT_MS=2000;
var PAGE_NOTE="Searching 30,000+ products – sorry if this is taking a little longer than expected.";
var CHAT_NOTE="Filtering through 30,000+ products – sorry if this is taking a little longer than expected. I may have a few questions for you shortly.";
var css=".mos-waitnote{display:block;margin-top:6px;font-size:13px;line-height:1.4;color:#5b6477;font-style:normal;animation:mos-wn-in .4s ease both}"+
".mos-waitnote--page{text-align:center;margin:8px auto 0;max-width:520px}"+
"@keyframes mos-wn-in{from{opacity:0;transform:translateY(3px)}to{opacity:1;transform:none}}";
function addCss(){if(document.getElementById("mos-waitnote-css"))return;var s=document.createElement("style");s.id="mos-waitnote-css";s.textContent=css;(document.head||document.documentElement).appendChild(s)}
function visible(el){return!!(el&&el.offsetParent!==null&&getComputedStyle(el).display!=="none")}
var seen=new WeakMap();
function tick(){var now=Date.now();
/* 1. results page loader */
var ld=document.getElementById("gen-loading-message"),pn=document.querySelector(".mos-waitnote--page");
if(visible(ld)){if(!seen.has(ld))seen.set(ld,now);
if(!pn&&now-seen.get(ld)>=WAIT_MS&&ld.parentNode){addCss();pn=document.createElement("div");pn.className="mos-waitnote mos-waitnote--page";pn.textContent=PAGE_NOTE;ld.parentNode.insertBefore(pn,ld.nextSibling)}}
else{if(ld)seen.delete(ld);if(pn)pn.remove()}
/* 2. chat status bubble */
var st=document.querySelectorAll("#shopify-ai-agent-v2 .shop-ai-message.assistant.status");
for(var i=0;i<st.length;i++){var m=st[i];if(!visible(m))continue;if(!seen.has(m))seen.set(m,now);
if(!m.querySelector(".mos-waitnote")&&now-seen.get(m)>=WAIT_MS){addCss();var n=document.createElement("span");n.className="mos-waitnote";n.textContent=CHAT_NOTE;m.appendChild(n)}}}
setInterval(tick,400);
})();
(function(){"use strict";
/* MOS 2026-09-29 — search dropdown "Collections" list.
   Parallel's dropdown lists the collections its products belong to. It looks them up with a loose
   title search (first 10), so unrelated ones slip in ("Physical Education Equipment" for
   "exercise books") and sale/promo collections crowd out categories. On the empty dropdown
   ("Recommended for you") it often shows nothing at all.
   This keeps only exact title matches, drops sale and promo collections (brand collections stay), orders them by how many
   of the dropdown's products sit in each one (max 6), and fills the empty-dropdown list too. */
if(window.__mosColFix)return;window.__mosColFix=3;
var prev=window.fetch;if(typeof prev!=="function")return;
var SKIP=/\b(sale|clearance|affordable|back to|deals?|best ?sell|new arrivals?|all products|specials?|gifts?|essentials|reorder)\b/i,MAX=6;
var last=Promise.resolve(null),lastPer=Promise.resolve(null);
function tally(prods){var c={},brands={};(prods||[]).forEach(function(p){if(p&&p.vendor)brands[String(p.vendor).toLowerCase()]=1;if(p&&p.brand)brands[String(p.brand).toLowerCase()]=1});
(prods||[]).forEach(function(p){(p&&p.collections||[]).forEach(function(t){if(!t||t==="All"||SKIP.test(t))return;   /* brand collections kept (Marty 30 Sep) */c[t]=(c[t]||0)+1})});return c}
function token(){try{return sessionStorage.getItem("parallel_public_token")||window.PARALLEL_PUBLIC_TOKEN||""}catch(e){return window.PARALLEL_PUBLIC_TOKEN||""}}
var Q="query getCollections($query: String!) { collections(first: 50, query: $query) { edges { node { title handle } } } }";
function lookup(counts,url,init){var want=Object.keys(counts||{}).sort(function(a,b){return counts[b]-counts[a]});if(!want.length)return Promise.resolve([]);
var q=want.slice(0,20).map(function(t){return'title:"'+t.replace(/"/g,'\\"')+'"'}).join(" OR ");
var u=url||location.origin+"/api/2023-01/graphql.json",h=init&&init.headers||{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":token()};
return prev.call(window,u,{method:"POST",headers:h,body:JSON.stringify({query:Q,variables:{query:q}})}).then(function(r){return r.json()}).then(function(j){
var seen={},edges=(j&&j.data&&j.data.collections&&j.data.collections.edges||[]).filter(function(e){if(!counts[e.node.title]||seen[e.node.title])return false;seen[e.node.title]=1;return true});
edges.sort(function(a,b){return counts[b.node.title]-counts[a.node.title]});return edges.slice(0,MAX)}).catch(function(){return[]})}
window.fetch=function(input,init){var self=this,args=arguments;
var url=typeof input==="string"?input:input&&input.url||"";
var m=/api\.storefrontagent\.com\/agents\/(suggest|personalize)\b/.exec(url);
if(m){var p=prev.apply(self,args),t=p.then(function(r){return r&&r.ok?r.clone().json().then(function(d){return tally(d&&d.products)}):null}).catch(function(){return null});
if(m[1]==="suggest")last=t;else lastPer=t;return p}
if(/\/api\/[0-9-]+\/graphql\.json/.test(url)&&init&&typeof init.body==="string"&&init.body.indexOf("getCollections")>=0){
var inp=document.querySelector(".gs-search-header__input");
var src=inp&&!String(inp.value||"").trim()?lastPer:last;
return src.then(function(counts){if(!counts)return prev.apply(self,args);
return lookup(counts,url,init).then(function(edges){return new Response(JSON.stringify({data:{collections:{edges:edges}}}),{status:200,headers:{"Content-Type":"application/json"}})})})}
return prev.apply(self,args)};
/* Empty dropdown: Parallel doesn't always run its lookup there, so fill the list ourselves. */
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]})}
var busy=false,CACHE={};   /* one lookup per set of products, not one every 700ms */
function fillEmpty(){var list=document.querySelector(".gs-predictive-search__collection-list");if(!list||busy||list.children.length)return;
var inp=document.querySelector(".gs-search-header__input");
if(inp&&String(inp.value||"").trim())return;if(!list.offsetParent)return;
busy=true;lastPer.then(function(counts){if(!counts)return[];var k=JSON.stringify(counts);if(CACHE[k])return CACHE[k];return CACHE[k]=lookup(counts)}).then(function(edges){busy=false;
if(!edges.length||list.children.length)return;if(inp&&String(inp.value||"").trim())return;
list.innerHTML=edges.map(function(e,i){var u="/collections/"+e.node.handle;return'<li class="gs-predictive-search__collection-item"><a href="'+esc(u)+'" class="gs-predictive-search__collection-link" data-collection-handle="'+esc(e.node.handle)+'" data-collection-url="'+esc(u)+'" data-position="'+(i+1)+'">'+esc(e.node.title)+"</a></li>"}).join("")})}
setInterval(fillEmpty,700);
})();

(function(){"use strict";
/* MOS 2026-09-30 — collection grid safety net (stopgap until Parallel fixes it).
   On 30 Sep Parallel's collection API (agents/merchandising, get_collection_products) started
   answering "products":[] for Ink & Toner, Desk & Organisation, Boards & Visual Communication,
   Science & STEM and others, so those pages showed "0 Products / No results".
   If Parallel returns no products for page 1 of a collection with no filters ticked, this fills the
   grid from Shopify's own collection (Storefront API) instead: Brand / Categories / Stock filters,
   the price slider, sorting (Featured, Best selling, Newest, Price) and "Load more" are all then
   served from Shopify for that page view. Up to POOL_MAX products per sort order are used.
   Every page load asks Parallel first, so this switches itself off once Parallel answers again. */
if(window.__mosColBackfill)return;window.__mosColBackfill=1;
var prev=window.fetch;if(typeof prev!=="function")return;
var PER=24,POOL_MAX=1000,BATCH=250;
function token(){try{return window.PARALLEL_PUBLIC_TOKEN||sessionStorage.getItem("parallel_public_token")||""}catch(e){return window.PARALLEL_PUBLIC_TOKEN||""}}
var GQL="query($id:ID!,$n:Int!,$c:String,$s:ProductCollectionSortKeys,$r:Boolean){collection(id:$id){products(first:$n,after:$c,sortKey:$s,reverse:$r){pageInfo{hasNextPage endCursor} nodes{id handle title vendor productType featuredImage{url} collections(first:12){nodes{title}} variants(first:1){nodes{id sku title availableForSale price{amount} compareAtPrice{amount}}}}}}}";
var SORTS=[{value:"featured",label_key:"featured",label:"Featured"},{value:"best-selling",label_key:"bestSelling",label:"Best selling"},{value:"newest",label_key:"newest",label:"Newest"},{value:"price-ascending",label_key:"priceLowToHigh",label:"Price: low to high"},{value:"price-descending",label_key:"priceHighToLow",label:"Price: high to low"}];
function sortKey(s){s=String(s||"");
if(/best/.test(s))return["BEST_SELLING",false];if(/new|created/.test(s))return["CREATED",true];
if(/^price-asc/.test(s))return["PRICE",false];if(/^price-desc/.test(s))return["PRICE",true];return["COLLECTION_DEFAULT",false]}
function toCard(p){var v=p.variants&&p.variants.nodes&&p.variants.nodes[0];if(!v)return null;
var price=+(v.price&&v.price.amount)||0,cmp=v.compareAtPrice?+v.compareAtPrice.amount:null;
return{product_id:p.id,imageUrl:p.featuredImage&&p.featuredImage.url||"",title:p.title,vendor:p.vendor,brand:p.vendor,type:p.productType,sku:v.sku,
productUrl:"/products/"+p.handle,price:price,lowest_price:price,compare_at_price:cmp,currency:"AUD",relevance_score:1,colors:[],metafields:{},
collections:(p.collections&&p.collections.nodes||[]).map(function(c){return c.title}),
variants:[{id:v.id,sku:v.sku,title:v.title,image:null,price:price,compare_at_price:cmp,is_available:!!v.availableForSale,is_sellable:!!v.availableForSale}]}}
var POOL={},MODE={};
function pool(id,sort){var sk=sortKey(sort),key=id+"|"+sk.join(",");if(POOL[key])return POOL[key];
var t=token();if(!t)return Promise.resolve([]);
var out=[];function step(cursor){
return prev.call(window,location.origin+"/api/2025-04/graphql.json",{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},
body:JSON.stringify({query:GQL,variables:{id:id,n:BATCH,c:cursor||null,s:sk[0],r:sk[1]}})})
.then(function(r){return r.ok?r.json():null}).then(function(j){var pr=j&&j.data&&j.data.collection&&j.data.collection.products;if(!pr)return out;
(pr.nodes||[]).forEach(function(p){var c=toCard(p);if(c)out.push(c)});
if(pr.pageInfo&&pr.pageInfo.hasNextPage&&out.length<POOL_MAX)return step(pr.pageInfo.endCursor);return out})}
POOL[key]=step(null).catch(function(){return out}).then(function(r){if(!r.length)delete POOL[key];return r});return POOL[key]}
function hasVals(v){return Array.isArray(v)?v.length>0:v!=null&&v!==""}
function cleanFilters(f){var o={};Object.keys(f||{}).forEach(function(k){if(hasVals(f[k]))o[k]=f[k]});return o}
function test(f,pmin,pmax){var tests=[];
Object.keys(f).forEach(function(k){var v=[].concat(f[k]).map(String);
if(k==="brand")tests.push(function(p){return v.indexOf(String(p.brand))>=0});
else if(k==="type")tests.push(function(p){return v.indexOf(String(p.type))>=0});
else if(k==="availability"){if(v.indexOf("In Stock")>=0)tests.push(function(p){return p.variants[0].is_available})}
else if(k==="price_min"){pmin=pmin||f[k]}else if(k==="price_max"){pmax=pmax||f[k]}});
if(pmin)tests.push(function(p){return p.price>=+pmin});if(pmax)tests.push(function(p){return p.price<=+pmax});
return function(p){return tests.every(function(t){return t(p)})}}
function termsF(prods,get,label,field,dl,lk){var c={};prods.forEach(function(p){var v=get(p);if(v)c[v]=(c[v]||0)+1});
var o=Object.keys(c).sort(function(a,b){return c[b]-c[a]||a.localeCompare(b)}).map(function(v){return{value:v,label:v,count:c[v]}});
return o.length?{label:label,field:field,type:"terms",options:o,default_label:dl,label_key:lk}:null}
function facets(prods){return[termsF(prods,function(p){return p.brand},"Brand","brand","Brand","brand"),
termsF(prods,function(p){return p.type},"Categories","type","Product Type","categories"),
termsF(prods,function(p){return p.variants[0].is_available?"In Stock":null},"Stock","availability","Availability","stock")].filter(Boolean)}
function stats(prods){var pr=prods.map(function(p){return+p.price}).filter(function(x){return x>0});return{min_price:pr.length?Math.floor(Math.min.apply(null,pr)):0,max_price:pr.length?Math.ceil(Math.max.apply(null,pr)):0,currency:"AUD"}}
var BASEF={};
function serve(body){var id=body.collection_id,page=body.page||1,f=cleanFilters(body.filters);
return Promise.all([pool(id,"featured"),pool(id,body.sort_by)]).then(function(r){var all=r[0],sorted=r[1];if(!sorted.length)return null;
if(!BASEF[id])BASEF[id]={facets:facets(all),stats:stats(all)};
var list=sorted.filter(test(f,body.price_min,body.price_max)),items=list.slice((page-1)*PER,page*PER),total=list.length,pages=Math.max(1,Math.ceil(total/PER));
var data={products:items,result_count:total,filters:f,facets:BASEF[id].facets,facets_pending:false,facets_stale:false,facets_source:"calculated",sort_options:SORTS,stats:BASEF[id].stats,
pagination:{result_count:total,begin:items.length?(page-1)*PER+1:0,end:(page-1)*PER+items.length,current_page:page,total_pages:pages,previous_page:page>1?page-1:0,next_page:page<pages?page+1:0,per_page:PER,default_per_page:PER},mos_fallback:true};
return new Response(JSON.stringify(data),{status:200,statusText:"OK",headers:{"Content-Type":"application/json"}})})}
window.fetch=function(input,init){var self=this,args=arguments;
var url=typeof input==="string"?input:input&&input.url||"";
if(!/api\.storefrontagent\.com\/agents\/merchandising\b/.test(url)||!init||typeof init.body!=="string")return prev.apply(self,args);
var body;try{body=JSON.parse(init.body)}catch(e){return prev.apply(self,args)}
if(body.event_type!=="get_collection_products"||!/^gid:\/\/shopify\/Collection\/\d+$/.test(String(body.collection_id||"")))return prev.apply(self,args);
var id=body.collection_id;
if(MODE[id]==="shop")return serve(body).then(function(res){return res||prev.apply(self,args)});
var first=(body.page||1)===1&&!Object.keys(cleanFilters(body.filters)).length&&!body.price_min&&!body.price_max;
return prev.apply(self,args).then(function(res){if(!first||!res||!res.ok)return res;
return res.clone().json().then(function(d){if(d&&Array.isArray(d.products)&&d.products.length)return res;
return serve(body).then(function(alt){if(!alt)return res;MODE[id]="shop";return alt})}).catch(function(){return res})})};
})();
(function(){"use strict";
/* MOS 2026-09-29 — Mega Concierge: clickable answers + questions before products.
   When the assistant's latest reply asks a question with a list of choices ("snap-off utility
   cutter, rotary cutter, craft knife or guillotine trimmer?", "(e.g., Year 1, Year 2, Year 3/4)")
   or a yes/no question, pill buttons appear under it:
     - single-choice: click a pill and it is sent straight away;
     - multi-choice ("all that apply", "any of"...): tick pills, then Submit;
     - "Something else" puts the cursor in the text box.
   Product cards the assistant shows while it is still asking are tucked behind a
   "Show N suggested products" link until the customer answers.
   Uses window.ParallelEveV2Chat.sendMessage. Does nothing if a reply can't be parsed. */
if(window.__mosPills)return;window.__mosPills=1;
var css=".mos-pills{display:flex;flex-wrap:wrap;gap:8px;margin:10px 0 4px;padding:0}"+
".mos-pill{border:1.5px solid #1e3f8f;background:#fff;color:#1e3f8f;border-radius:999px;padding:7px 14px;font-size:13.5px;line-height:1.2;cursor:pointer;font-weight:600;transition:background .15s,color .15s}"+
".mos-pill:hover{background:#eef3ff}.mos-pill.on{background:#1e3f8f;color:#fff}"+
".mos-pill.ghost{border-style:dashed;font-weight:500}"+
".mos-pill.go{background:#1e3f8f;color:#fff;border-color:#1e3f8f}.mos-pill.go[disabled]{opacity:.45;cursor:default}"+
".mos-pills-hint{width:100%;font-size:12px;color:#5b6477;margin:0 0 2px}"+
".mos-tucked{display:none!important}"+
".mos-showprods{display:inline-block;margin:6px 0 2px;font-size:13px;color:#1e3f8f;text-decoration:underline;cursor:pointer;background:none;border:0;padding:0}";
function addCss(){if(document.getElementById("mos-pills-css"))return;var s=document.createElement("style");s.id="mos-pills-css";s.textContent=css;document.head.appendChild(s)}
function clean(s){return String(s||"").replace(/\s+/g," ").trim()}
function tidy(o){o=clean(o).replace(/[()\[\]]/g,"").replace(/^(?:(?:and|or|maybe|perhaps|either|by)\s+)+/i,"").replace(/^(?:a|an|the)\s+/i,"").replace(/[.?!:;]+$/,"").trim();
return o?o.charAt(0).toUpperCase()+o.slice(1):""}
/* Split "x, y, z or w" into items. */
function splitList(s){var parts=s.split(/\s*,\s*|\s+or\s+|\s*\/\s+(?=[A-Za-z])/i).map(clean).filter(Boolean);return parts}
var LEAD=/^(?:would you (?:prefer|like|rather)|do you (?:need|want|prefer|have|use)|are you (?:looking for|after)|is (?:it|this)(?: for)?|which (?:one )?(?:do|would) you (?:need|prefer|want)|should (?:it|they) be)\s+/i;
function trimLead(first,rest){ /* "Are you looking for blades for a snap-off utility cutter" -> "snap-off utility cutter" */
var cut=[/.*\s(?:—|–|-)\s+/,/.*:\s*/,/.*\b(?:e\.g\.,?|for example,?|such as|like|including)\s+/i];
for(var i=0;i<cut.length;i++){var m=first.replace(cut[i],"");if(m!==first){first=m;break}}
if(rest.length&&rest.every(function(r){return/^(?:a|an)\s/i.test(r)})){var k=Math.max(first.lastIndexOf(" a "),first.lastIndexOf(" an "));if(k>=0)first=first.slice(k+1)}
var avg=Math.round(rest.reduce(function(n,r){return n+r.split(" ").length},0)/Math.max(1,rest.length))+1;
var w=first.split(" ");if(w.length>avg+1)first=w.slice(-avg).join(" ");return first}
function parse(text){text=clean(text);
var qs=text.match(/[^.?!]*\?(?:\s*\([^)]*\))?/g);if(!qs)return null;var q=clean(qs[qs.length-1]);
var multi=/\b(all that apply|any of (?:these|them|the)|select (?:all|any)|one or more|which ones)\b/i.test(q);
/* 1. "(e.g., A, B, C)" */
var eg=/\((?:e\.g\.,?|for example,?|such as|like)\s*([^)]+)\)/i.exec(q);
var items=null;
if(eg){items=splitList(eg[1].replace(/\s+etc\.?$/i,""))}
else{ /* 2. "... A, B, C or D?" / "... — A, B or C?" */
var body=q.replace(/\?.*$/,"").replace(/\([^)]*\)/g,"");
body=body.replace(/^.*(?:\s[—–-]\s|:\s|\be\.g\.,?\s|\bfor example,?\s|\bsuch as\s)/i,"");
if(/\bor\b/i.test(body)){var parts=body.split(/\s*,\s*|\s+or\s+/i).map(clean).filter(Boolean);
if(parts.length>=2){parts[0]=trimLead(parts[0].replace(LEAD,""),parts.slice(1));items=parts}}}
if(items){items=items.map(tidy).filter(function(x){return x&&x.split(" ").length<=6&&x.length<=40});
var seen={};items=items.filter(function(x){var k=x.toLowerCase();if(seen[k])return false;seen[k]=1;return true});
if(items.length>=2&&items.length<=8)return{q:q,items:items,multi:multi}}
/* 3. yes / no */
if(/^(do|does|did|are|is|would|should|can|could|will|have|has)\b/i.test(q)&&!/\bor\b/i.test(q))return{q:q,items:["Yes","No"],multi:false};
return null}
/* Bulleted options under a question: <li>Snap-off utility cutters (small or large blades)</li> */
function parseList(msg,text){var lis=[].slice.call(msg.querySelectorAll("li"));if(lis.length<2||lis.length>8)return null;
var first=clean(lis[0].innerText).slice(0,20),pre=clean(text).split(first)[0]||"";if(pre.indexOf("?")<0)return null;   /* question must come first */
var qs=pre.match(/[^.?!]*\?/g);if(!qs)return null;
var items=lis.map(function(li){return tidy(clean(li.innerText).replace(/\s*\([^)]*\)/g,"").replace(/\s+[—–-]\s+.*$/,"").replace(/:.*$/,""))})
.filter(function(x){return x&&x.split(" ").length<=6&&x.length<=40});
if(items.length<2)return null;var q=clean(qs[qs.length-1]);
return{q:q,items:items,multi:/\b(all that apply|any of|select (?:all|any)|one or more|which ones)\b/i.test(text)}}
function api(){return window.ParallelEveV2Chat}
function send(text){var a=api();if(!a)return;try{a.sendMessage(text)}catch(e){}}
function focusInput(){var a=api();try{var el=a.getElements().chatInput;el&&el.focus()}catch(e){}}
function render(row,p){addCss();var box=document.createElement("div");box.className="mos-pills";box.setAttribute("data-mos-q",p.q);
if(p.multi){var h=document.createElement("div");h.className="mos-pills-hint";h.textContent="Pick any that apply, then Submit";box.appendChild(h)}
var chosen=[];
p.items.forEach(function(t){var b=document.createElement("button");b.type="button";b.className="mos-pill";b.textContent=t;
b.addEventListener("click",function(){if(!p.multi){box.remove();send(t);return}
var i=chosen.indexOf(t);if(i>=0){chosen.splice(i,1);b.classList.remove("on")}else{chosen.push(t);b.classList.add("on")}go.disabled=!chosen.length});box.appendChild(b)});
var other=document.createElement("button");other.type="button";other.className="mos-pill ghost";other.textContent="Something else";other.addEventListener("click",focusInput);box.appendChild(other);
if(p.multi){var go=document.createElement("button");go.type="button";go.className="mos-pill go";go.textContent="Submit";go.disabled=true;
go.addEventListener("click",function(){if(!chosen.length)return;box.remove();send(chosen.length>1?chosen.slice(0,-1).join(", ")+" and "+chosen[chosen.length-1]:chosen[0])});box.appendChild(go)}
var wrap=row.querySelector(".shop-ai-message-content-wrapper")||row;wrap.appendChild(box)}
function tuck(rows,qi){ /* product rows after the last user message and before the question */
var start=qi;while(start>0&&!rows[start-1].classList.contains("user"))start--;
for(var i=start;i<qi;i++){var r=rows[i];if(!r.classList.contains("product-results")||r.classList.contains("mos-tucked")||r.getAttribute("data-mos-seen"))continue;
r.setAttribute("data-mos-seen","1");r.classList.add("mos-tucked");
var n=r.querySelectorAll(".shop-ai-product-scroller > *").length,link=document.createElement("button");link.type="button";link.className="mos-showprods";
link.textContent="Show "+(n||"")+" suggested product"+(n===1?"":"s");
(function(r,link){link.addEventListener("click",function(){r.classList.remove("mos-tucked");link.remove()})})(r,link);
rows[qi].querySelector(".shop-ai-message-content-wrapper").appendChild(link)}}
var lastDone=null;
function tick(){var root=document.getElementById("shopify-ai-agent-v2");if(!root)return;
if(root.querySelector(".shop-ai-message.assistant.status"))return;           /* still thinking */
var rows=[].slice.call(root.querySelectorAll(".shop-ai-chat-messages > .shop-ai-message-row"));if(!rows.length)return;
var li=rows.length-1,row=rows[li];
/* old pills are removed once anything newer arrives */
[].slice.call(root.querySelectorAll(".mos-pills")).forEach(function(b){if(!row.contains(b))b.remove()});
if(!row.classList.contains("assistant")||row.classList.contains("product-results"))return;
if(row===lastDone||row.querySelector(".mos-pills"))return;
var msg=row.querySelector(".shop-ai-message.assistant");if(!msg)return;
var text=msg.innerText;if(text.length<8)return;
/* wait until the reply has stopped streaming */
if(row.getAttribute("data-mos-len")!==String(text.length)){row.setAttribute("data-mos-len",String(text.length));return}
lastDone=row;var p=parseList(msg,text)||parse(text);if(!p)return;
if(!/A\$\s?\d/.test(text)&&li>0&&rows.slice(0,li).some(function(r){return r.classList.contains("user")}))tuck(rows,li);   /* not when it is recommending */
render(row,p)}
setInterval(tick,600);
window.__mosParsePills=parse;   /* for testing */
})();
